import React, { useState, useEffect } from 'react';
import axios from 'axios';
import useAuthStore from '../store/authStore';
import './Digest.css';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function Digest() {
  const [digest, setDigest] = useState(null);
  const [period, setPeriod] = useState('weekly');
  const [loading, setLoading] = useState(false);
  const { token } = useAuthStore();

  useEffect(() => {
    fetchDigest();
  }, [period]);

  const fetchDigest = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE}/digest`, {
        params: { period },
        headers: { Authorization: `Bearer ${token}` }
      });
      setDigest(response.data);
    } catch (error) {
      console.error('Error fetching digest:', error);
    } finally {
      setLoading(false);
    }
  };

  const sendDigest = async () => {
    try {
      const response = await axios.post(`${API_BASE}/digest/send`, { period }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert(`Digest generated: ${response.data.updatesIncluded} updates included.\n\n${response.data.message}`);
    } catch (error) {
      alert('Error sending digest: ' + error.message);
    }
  };

  if (loading) return <div className="digest-loading">Loading digest...</div>;

  return (
    <div className="digest-container">
      <h1>Email Digest</h1>

      <div className="digest-controls">
        <select value={period} onChange={(e) => setPeriod(e.target.value)}>
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
        </select>
        <button onClick={sendDigest} className="send-btn">Generate Digest</button>
      </div>

      {digest && (
        <div className="digest-content">
          <p className="digest-period">
            Period: {new Date(digest.startDate).toLocaleDateString()} - {new Date(digest.endDate).toLocaleDateString()}
          </p>
          <p className="digest-count">Total Updates: {digest.totalUpdates}</p>

          {Object.entries(digest.grouped).map(([source, updates]) => (
            <div key={source} className="digest-section">
              <h2>{source.toUpperCase()}</h2>
              <ul>
                {updates.map(update => (
                  <li key={update.id} className={`urgency-${update.urgency}`}>
                    <h3>{update.title}</h3>
                    <p>{update.description}</p>
                    <small>{new Date(update.published_at).toLocaleDateString()}</small>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Digest;
